import { API, api } from "./api";

interface IMasterRegisterFormRequest {
  token: string;
  contactName: string;
  contactSurname: string;
  phone: string;
  password: string;
  confirmPassword: string;
  accept_terms: boolean;
  consent_communication: boolean;
  consent_marketing: boolean;
}

export const masterAccount = api.injectEndpoints({
  endpoints: (builder) => ({
    postMasterAccountRegister: builder.mutation<
      unknown,
      IMasterRegisterFormRequest
    >({
      query: (body: IMasterRegisterFormRequest) => {
        return {
          url: API.postMasterAccountRegister.endpoint(),
          method: "POST",
          body,
        };
      },
    }),
    getMasterAccountValidateToken: builder.query<{ code: string }, string>({
      query: (token: string) => {
        return {
          url: API.postMasterAccountValidateToken.endpoint(token),
        };
      },
    }),
    postVerifyMasterPhone: builder.mutation<
      void,
      { phone: string; token: string; code: string }
    >({
      query: (body) => {
        return {
          url: API.postVerifyMasterPhone.endpoint(),
          method: "POST",
          body,
        };
      },
    }),
    postVerifyAgainMasterPhone: builder.mutation<void, { phone: string }>({
      query: (body) => {
        return {
          url: API.postVerifyAgainMasterPhone.endpoint(body.phone),
          method: "POST",
        };
      },
    }),
  }),
});

export const {
  usePostMasterAccountRegisterMutation,
  useGetMasterAccountValidateTokenQuery,
  useLazyGetMasterAccountValidateTokenQuery,
} = masterAccount;

export const { postMasterAccountRegister, getMasterAccountValidateToken } =
  masterAccount.endpoints;
